export * from './queryKeys'

export const USER_ROLES = [
  'owner',
  'folder_based',
  'billing_manager',
  'editor',
  'viewer',
  'no_access',
] as const
export const USER_STATUS = ['active', 'inactive', 'pending'] as const

export const USER_ROLE_OPTIONS = [
  {
    value: 'folder_based',
    label: 'Folder Based',
  },
  {
    value: 'billing_manager',
    label: 'Billing Manager',
  },
] as const
